module.exports = __webpack_public_path__ + "static/media/star_tall_240ce.5613eb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/climasense/phythophtora_palmivora/curativa/star_tall_240ce.png
// module id = 2298
// module chunks = 3